import GeolocationDispatcher from '@webclient/components/geolocation';

import PortalProvider from '@webclient/providers/PortalProvider';
import ReactQueryProvider from '@webclient/providers/ReactQueryProvider';
import ReCaptchaProvider from '@webclient/providers/ReCaptchaProvider';
import ReduxProvider from '@webclient/providers/ReduxProvider';
import StateUpdateProvider from '@webclient/providers/StateUpdateProvider';
import ThemeProvider from '@webclient/providers/ThemeProvider';
import ThemeSettingsProvider from '@webclient/providers/ThemeSettingsProvider';
import TranslationProvider from '@webclient/providers/TranslationProvider';
import WorkspaceProvider from '@webclient/providers/WorkspaceProvider';

import { ConfirmProvider } from 'material-ui-confirm';
import { IoProvider } from 'socket.io-react-hook';

export default function Providers({ children }: React.PropsWithChildren) {
  return (
    <ReactQueryProvider>
      <ReduxProvider>
        <IoProvider>
          <ThemeSettingsProvider>
            <ThemeProvider>
              <TranslationProvider>
                <WorkspaceProvider>
                  <StateUpdateProvider>
                    <ConfirmProvider
                      defaultOptions={{
                        confirmationButtonProps: {
                          variant: 'contained',
                        },
                        cancellationButtonProps: {
                          variant: 'outlined',
                        },
                      }}
                    >
                      <PortalProvider>
                        <GeolocationDispatcher>
                          <ReCaptchaProvider>{children}</ReCaptchaProvider>
                        </GeolocationDispatcher>
                      </PortalProvider>
                    </ConfirmProvider>
                  </StateUpdateProvider>
                </WorkspaceProvider>
              </TranslationProvider>
            </ThemeProvider>
          </ThemeSettingsProvider>
        </IoProvider>
      </ReduxProvider>
    </ReactQueryProvider>
  );
}
